var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useAppSelector } from '../../../../store';
import { participantsSelector } from '../../../../store/slices/participantSlice';
const ScreenShareIcon = ({ userId }) => {
    _react_refresh_temp_2();
    const participant = useAppSelector((state) => participantsSelector.selectById(state, userId));
    const render = useMemo(() => {
        if (participant === null || participant === void 0 ? void 0 : participant.screenShareTrack) {
            return (_jsx("div", { className: "screen-share ltr:mr-2 rtl:ml-2 cursor-pointer", children: _jsx("i", { className: "pnm-screen-share secondaryColor text-[10px]" }) }));
        }
        return null;
    }, [participant === null || participant === void 0 ? void 0 : participant.screenShareTrack]);
    return _jsx(_Fragment, { children: render });
};
_react_refresh_temp_1 = ScreenShareIcon;
$RefreshReg$(_react_refresh_temp_1, "ScreenShareIcon");
_react_refresh_temp_2(ScreenShareIcon, "mFor7mPvO6NzrWd/wtuReDr2lkg=", false, () => [useAppSelector]);
export default ScreenShareIcon;
